import Constants from "../../utils/CommonConstants";

// Sapna's SalesOpportunityController — call recording lookup.
// FE talks to Sapna only; Sapna resolves the housing profile to its
// opportunities and does the Mystique lookup server-side. Sapna is reached
// through the relative `/sapna` nginx proxy prefix, not a DOMAINS.* env var,
// so this is a same-origin path.
export const CALL_INSIGHTS_API_BASE = "/sapna/v1/opportunity/call-recording";

export const CALL_INSIGHTS_LOADING = "CALL_INSIGHTS_LOADING";
export const CALL_INSIGHTS_SUCCESS = "CALL_INSIGHTS_SUCCESS";
export const CALL_INSIGHTS_FAILURE = "CALL_INSIGHTS_FAILURE";
export const CALL_INSIGHTS_RESET = "CALL_INSIGHTS_RESET";

// Roles the endpoint permits. Anything else is rejected with a 401 before the
// handler runs, so the section gates on these client-side too rather than
// firing a request that cannot succeed.
//
// The contract names the third role "Lookup Admin"; an earlier revision called
// it "Lookup Master Data (Lookup admin)". Those are two distinct role strings
// here, so both are allowed — if the backend honours only one, the other just
// gets the silent 401 that hides the section anyway.
export const CALL_INSIGHTS_ALLOWED_ROLES = [
  Constants.modifyRoles.AGENT_ROLE, // Housing Sales Agent
  Constants.modifyRoles.MANAGER_ROLE, // Housing Sales Manager
  Constants.lookupAdminRole, // Lookup Admin
  Constants.masterData, // LOOKUP_MASTER_DATA
];

// Wire format for callStartTime / callEndTime. No timezone suffix and no
// milliseconds, so it is not a reliable Date.parse() input.
export const CALL_TIME_FORMAT = "yyyy-MM-dd HH:mm:ss";

// Sapna always looks back a fixed 3 months; there is no date param yet.
export const CALL_INSIGHTS_WINDOW_LABEL = "last 3 months";
